<template>
    <div>
        <div class="button"
             v-if="isPromise"
             @click="load">
            加载
        </div>
        <div v-if="!isPromise"
             class="md-editor">
            <textarea class="md-code"
                      ref="input"
                      @input="throttledRender"/>
            <markdown-wrapper class="md-render"
                              :source="renderSource"
                              :element="`.md-render[uuid=${uuid}]`"
                              :uuid="uuid"/>

        </div>
    </div>
</template>

<script>
	import MarkdownWrapper from "../MarkdownWrapper";
	export default {
		name: "MarkdownEditor",
		components: {MarkdownWrapper},
		props: {
			data: {
				required: true
			}
		},
		data() {
			return {
				selfData: "",
                uuid: "blank",
                renderSource: "",
				throttledRender: this.$throttle(this.updateRender, 1000)
			}
		},
		created() {
			this.selfData = this.data;
			this.uuid = "md-xxxxxxxx".replace(/x/g,
				() => (Math.random() * 16 | 0).toString(16));
		},
		methods: {
			getValue() {
				return this.source;
			},
			load() {
				this.selfData(result => {
					this.selfData = result;
					this.renderSource = result;
					setImmediate(() => {
						this.$refs.input.value = result;
					});
				}, err => {
					console.log(err);
				});
			},
            updateRender() {
				this.renderSource = this.$refs.input.value;
            }
		},
		computed: {
			isPromise() {
				return typeof (this.selfData) === "function";
			},
			source() {
				if (this.isPromise) {
					return this.selfData;
				} else {
                    return this.$refs.input.value;
				}
			}
		}
	}
</script>

<style scoped lang="scss">
    .button {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        padding: 0 16px;
    }

    div {
        height: auto;
    }

    .md-editor {
        display: flex;
        width: 100%;
        max-width: 100%;
        height: 240px;
        overflow: scroll;
        resize: vertical;
    }

    .md-code {
        resize: horizontal;
        width: 50%;
        flex-grow: 1;
    }

    .md-render {
        zoom: 0.8;
        max-height: 100%;
        width: 50%;
        flex-grow: 1;
        overflow: scroll;
        border: $solid;
        margin-left: 4px;
        padding: 0 8px;
    }
</style>